import { FC } from 'react';
import clsx from 'clsx';
import { useMergedStyles } from 'hooks/useMergedStyles';

import { Styles } from 'types/styles';
import styles from './LoaderCircle.module.scss';

type Props = {
  text?: string;
  newStyles?: Styles;
  additionalClass?: string;
};
const LoaderCircle: FC<Props> = ({ newStyles = {}, text = '', additionalClass = '' }) => {
  const mergedStyles = useMergedStyles(styles, newStyles);

  return (
    <div
      className={clsx(mergedStyles['loader-circle-wrapper'], {
        [additionalClass]: additionalClass,
      })}
    >
      <div className={mergedStyles['loader-circle']}>
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
      {text !== '' && <div className={mergedStyles['loader-circle-text']}>{text}</div>}
    </div>
  );
};

export default LoaderCircle;
